import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for Boolean
 * Only used for deserializing booleans when they could potentially come through as strings,
 * as is the case for URLSearchParams
 */
export const booleanSerializer = CreateSerializer(undefined, deserializeBoolean);
function deserializeBoolean(value) {
    return value === 'true';
}
